import React from 'react'
import styled from 'styled-components';
import { Link  } from "gatsby"
import { useTranslation } from 'react-i18next';
import spiciness1 from "../assets/spiciness-1.png";
import spiciness2 from "../assets/spiciness-2.png";
import spiciness3 from "../assets/spiciness-3.png";
import spiciness0 from "../assets/spiciness-0.png";
import usePublicAudioContext from '../../../context/AudioPlayerContext';

  function getDuration(seconds){
    let date = new Date(0);
    date.setSeconds(seconds);
    return date.toISOString().substr(14, 5);
  }



const ListViewItem = (props) => {
  const { t } = useTranslation()
  const { title, thumbnail, voices, mainTag, spiciness, duration, slug, audioUrl, type } = props
  const { setCurrentTrack } = usePublicAudioContext()

  const getLink = ({slug, type, t}) => {
    if(type === "audiobook") return `${t('urls.audiobook')}${slug}`
    if(type === "community") return `${t('urls.community-story')}${slug}`
    if(type === "sleep") return `${t('urls.sleep')}${slug}`
    if(type === "story") return `${t('urls.story')}${slug}`
  }
    
  const handlePlayClick = () => {
    setCurrentTrack({url:audioUrl, title, voices, cover:thumbnail})
    /* audioRef.current.pause() // to get autoplay working
    audioRef.current.play() // to get autoplay working */
  }

  return (
    <ResultItem>
      <CustomLink to={getLink({slug, type, t})}>
        <ResultImage> 
          <CoverImage
            src={thumbnail}
            alt={`Story Cover Image for: ${title}`}
            style={{borderRadius:"4px"}}
          />
        </ResultImage>
        <StoryInfoWrapper>

          <StoryMainInfo>
            <StoryTitle>{title}</StoryTitle>
            <StorySubtitle >
              {" "}
              {voices?.[0]?.slug !== "placeholder" &&
              <>
              {voices[0].name}
              {voices[1]
                ? ` + ${voices[1].name} • `
                : ` • `}
              </>
              }
              {mainTag}
            </StorySubtitle>
          </StoryMainInfo>

          <StoryMeta>
            {spiciness === "0" && <Spiciness src={spiciness0} />}
            {spiciness === "1" && <Spiciness src={spiciness1} />}
            {spiciness === "2" && <Spiciness src={spiciness2} />}
            {spiciness === "3" && <Spiciness src={spiciness3} />}
            <Duration>{getDuration(duration)}</Duration>
          </StoryMeta>
        </StoryInfoWrapper>
      </CustomLink>
      <PlayButtonWrapper>
        <PlayButton onClick={()=> handlePlayClick()}><PlayIcon/></PlayButton>
      </PlayButtonWrapper>
    </ResultItem>
  )
}

export default ListViewItem

const CoverImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
`;


const CustomLink =  styled(Link)`
  width:85%;
  display: flex;
  text-decoration: none;
`

const ResultItem = styled.div`
  display: flex;
  margin-bottom: 10px;
  background-color: white;
  position: relative;
  padding: 10px 10px;
  border-radius: 5px;
`

const ResultImage = styled.div`
  display: flex;
  width:75px;
  min-width:75px;
  position: relative;
  min-height: 100px;
  margin-right: 8px;
  overflow: hidden;
`

const StoryMainInfo = styled.div`
  margin: 0px;
  padding-top:15px;
`

const StoryTitle = styled.h2`
  font-size: 1.15rem !important;
  line-height: 1.3rem;
  font-family:${props => props.theme.mainFontHeading};
  margin: 0px 0px 5px 0px;
  @media (max-width: 330px) {
    font-size: 1rem !important;
  }
  text-decoration: none;
`

const StoryInfoWrapper = styled.div`
  display:flex;
  width:75%;
`

const StorySubtitle = styled.h4`
  font-size: 11px;
  margin: 0px 0px;
  text-transform: uppercase;
  font-family: 'Poppins';
  color: #A68C8A;
  font-weight: bold;
  letter-spacing: 0.05em;
  line-height: 14px;
`

const StoryMeta = styled.div`
  display:flex;
  position: absolute;
  bottom: 10px;
`

const Spiciness = styled.img`
  height: 20px;
`

const PlayButtonWrapper = styled.div`
  width:15%;
  display:flex;
  align-items:center;
  justify-content: center;
`

const PlayButton = styled.div`
  height:33px;
  width:33px;
  border-radius: 50%;
  background-color:  #f19d9a;
  display:flex;
  align-items:center;
  justify-content: center;
`

const PlayIcon =  styled.div`
  box-sizing: border-box;
  border-style: solid;
  border-width: 7px 0px 7px 10px;
  border-color: transparent transparent transparent white;
  margin-left: 3px;
`

const Duration = styled.div`
  font-family: 'Poppins';
  font-size: 12px;
  margin: 2px 0 0 10px;
`